export default __webpack_public_path__ + "static/media/AdobeStock_471939881.119bfc73.jpg";